import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useAuth0 } from '@auth0/auth0-react'

import StyleGuide from '../Global/StyleGuide'
import Grid from '../Global/Grid'

import { useApiContext } from '../Hooks/useApiContext'
import { extractServicer } from '../Utils/apiExtractors'

import CyberCrimeWarning from './CyberCrimeWarning'
import CybercrimeWarningDesktop from './CybercrimeWarningDesktop'
import { verifyBankAccount, verifyLoanNumber } from '../services/bankVerification.service';
import { getBrowserSessionId } from '../Utils/session'
import useWindowSize from '../Hooks/useWindowSize'

const PageWarning = styled.div`
  max-width: 790px;
  margin: 0 auto 20px;
  margin-top: 48px;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;

  color: var(--Red, #ff5050);
  text-align: center;
    @media (max-width: ${({ theme }) => theme.breakPoints.xSmall}) {
   text-align: left;
    margin-top: 10px;
    font-size: 20px;
    margin-left: 0px !important;
  }
 
`;

const PageTitle = styled.h1`
  max-width: 376px;
  height: 22px;
  margin: 30px auto 10px;
  font-size: 30px !important;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  line-height: 34px;
  margin-top: 20px;
  color: #000;
  text-align: center;

  @media (max-width: 768px) {
    height: auto;
    padding: 8px 16px;
    font-size: 29px !important;
    line-height: 60px !important;
  }
`;



const StyledPage = styled.div`
 
  background: rgb(248, 251, 255) !important;

  padding: 40px 0 80px;

  /* ===== HEADER ===== */
  .page-title {
    text-align: center;
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 10px;
  }

  .page-warning {
    text-align: center;
    color: #ff0000;
    font-size: 14px;
    margin-bottom: 30px;
  }

  .instructions {
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 20px;
  }

  /* ===== FORM ===== */
  .form-wrapper {
    max-width: 420px;
    margin: 0 auto;
    text-align: center;
  }

  .form-wrapper input {
    width: 100%;
    height: 44px;
    padding: 0 12px;
    border: 1px solid #ccc;
    border-radius: 6px;
    margin-bottom: 16px;
    font-size: 14px;
  }

  .form-wrapper button {
    width: 100%;
    height: 44px;
    background: #4a5568;
    color: #fff;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }
  button:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}


 .cybercrime-wrapper {
  margin-top: 40px;
   @media (min-width: 768px) {
   width: 800px !important;
    margin-left: -75px !important;
  }
}

.cybercrime-wrapper > section {
  margin-left: auto;
  margin-right: auto;
   
}
  .cybercrime-wrapper section h2 {
   font-family: 'Lato', sans-serif;
 @media (max-width: ${({ theme }) => theme.breakPoints.xSmall}) {
   font-size: 19px !important;
  
   }

}

`
const Instructions = styled.div`
  max-width: 879px;
  min-height: 72px;
  margin: 0 auto 24px;

  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;

  color: #000;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 24px;
    padding: 0 16px;
    min-height: auto;
  }
`;

const ErrorBanner = styled.div`
  max-width: 520px;
  margin: 52px auto 24px;
  padding: 12px 16px;

  display: flex;
  gap: 12px;
  align-items: flex-start;

  background: #fff1e8;
  border-radius: 12px;

  font-family: 'Lato', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #000;

  @media (max-width: 768px) {
    margin: 0 16px 24px;
  }
`;


const ErrorIcon = styled.span`
  min-width: 20px;
  height: 20px;
  border-radius: 50%;

  background: #ff5050;
  color: #fff;

  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: 700;
  font-size: 14px;
`;
const LockedErrorBanner = styled(ErrorBanner)`
  font-size: 16px;
  line-height: 22px;
`;

const LockedErrorText = styled.div`
  max-width: 603px;

  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 26px;

  color: #000;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 22px;
  }
`;
const FormLabel = styled.label`
  display: block;
  max-width: 264px;

  font-family: 'Lato', sans-serif;
  font-weight: 500;      
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0;

  color: #000;
  vertical-align: middle;

  margin-bottom: 6px;
`;
const SuccessBanner = styled.div`
  max-width: 640px;
  margin: 60px auto 24px;
  padding: 20px 24px;

  display: flex;
  align-items: flex-start;
  gap: 16px;

  background: #ecffe9;
  border-radius: 16px;

  font-family: 'Lato', sans-serif;
  font-size: 20px;
  line-height: 26px;
  color: #000;
`;

const SuccessIcon = styled.span`
  min-width: 28px;
  height: 28px;
  border-radius: 50%;

  background: #22c55e;
  color: #fff;

  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: 700;
  font-size: 16px;
`;
const SuccessText = styled.div`
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: 0;
  vertical-align: middle;
  color: #000;
`;


const HomeToolkit = () => {
 
  const { isAuthenticated, isLoading } = useAuth0()
  const { loan } = useApiContext()
  const { data: loanData } = loan
  const {
  isMobile,
  isTablet,
} = useWindowSize()

const isDesktop = !isMobile && !isTablet


const [loanNumber, setLoanNumber] = useState('')
const [isInvalidLoan, setIsInvalidLoan] = useState(false);
const [attemptCount, setAttemptCount] = useState(0); 
const [isLoanValid, setIsLoanValid] = useState(false);
const [bankAttemptCount, setBankAttemptCount] = useState(0);
const [isBankVerified, setIsBankVerified] = useState(false);
const [fromBankFailure, setFromBankFailure] = useState(false);

const MAX_ATTEMPTS = 3;
const showStandardError = isInvalidLoan && attemptCount < MAX_ATTEMPTS;
const showLockedError =
  (!isLoanValid && attemptCount >= MAX_ATTEMPTS) ||
  (isLoanValid && bankAttemptCount >= MAX_ATTEMPTS);
const [abaNumber, setAbaNumber] = useState('');
const [accountNumber, setAccountNumber] = useState('');
const [isBankLoading, setIsBankLoading] = useState(false);
const [forceBankLock, setForceBankLock] = useState(false);
const isLoanNumberEntered = loanNumber.trim().length >= 5;

const isAbaValid = abaNumber.length === 9;
const isAccountValid = accountNumber.length > 0;

const isBankFormValid = isAbaValid && isAccountValid;



  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      extractServicer(loanData)
    }
  }, [isAuthenticated, isLoading, loanData])

 


const handleConfirm = async () => {
  const getConfirmAnalyticsPayload = () => {
 
  const payload = {
    activity: 'wiring instructions',
    page: 'confirm-wiring-instructions',
    stage: !isLoanValid ? 'loan_verification' : 'bank_verification',
    loan_number_entered: Boolean(loanNumber),
    key: loanNumber,
  };

  
  if (isLoanValid) {
    payload.aba_entered = Boolean(abaNumber);
    payload.account_entered = Boolean(accountNumber);
    payload.category_name = abaNumber && accountNumber ? 'Bank Info Entered, true' : 'Bank Info Not Entered, false';
  }

  return payload;
};

   if (window.analytics) {
    window.analytics.track(
      'Wiring Instructions Confirm Clicked',
        getConfirmAnalyticsPayload()
    )
    
  }
    
  if (!isLoanValid && !forceBankLock) {
     let isLoanApiValid = false;
  try {
      isLoanApiValid = await verifyLoanNumber({ loanNumber });
    } catch (e) {
      console.error('Loan verify API error:', e);
    }
    if (window.analytics) {
      window.analytics.track(
        isLoanApiValid
          ? 'Wiring Instructions Verification Succeeded'
          : 'Wiring Instructions Verification Failed',
        {
          activity: 'wiring instructions',
          api_name: 'verifyLoanNumber',
          stage: 'loan_verification',
          result: isLoanApiValid ? 'success' : 'failure',
          attempt_number: attemptCount + 1,
           key: loanNumber
        }
      )
    }
    if (!loanNumber || !isLoanApiValid) {
      setAttemptCount((prev) => prev + 1);
      setIsInvalidLoan(true);
      setFromBankFailure(false);
      return;
    }

    // Loan number valid → go to bank screen
    setFromBankFailure(false); 
    setIsInvalidLoan(false);
    setAttemptCount(0);
    setIsLoanValid(true);
    return;
  }

 
  setIsBankLoading(true);

  let isValid = false;
  try {
    const sessionId = getBrowserSessionId();
    isValid = await verifyBankAccount({
      sessionId: sessionId,
      loanNumber,
      abaNumber,
      accountNumber,
    });
  } catch (error) {
    console.error('Bank API error:', error);
  } finally {
    setIsBankLoading(false);
  }
if (window.analytics) {
    window.analytics.track(
      isValid
        ? 'Wiring Instructions Verification Succeeded'
        : 'Wiring Instructions Verification Failed',
      {
        activity: 'wiring instructions',
        api_name: 'verifyBankAccount',
        stage: 'bank_verification',
        result: isValid ? 'success' : 'failure',
        attempt_number: bankAttemptCount + 1,
        key: loanNumber,
        category_name: abaNumber && accountNumber ? true : false,
      }
    )
  }
  //  BANK DETAILS INVALID
  if (!isValid) {
    setBankAttemptCount((prev) => {
      const nextAttempt = prev + 1;
      console.log('Bank attempt:', nextAttempt);

      // Attempts 1 & 2 → send user back to loan screen
      if (nextAttempt < MAX_ATTEMPTS) {
        setFromBankFailure(true);
        setIsLoanValid(false);
        setLoanNumber('');
        setIsInvalidLoan(true);
        setAbaNumber('');
        setAccountNumber('');
      }

      // Attempt 3 → LOCK bank screen
      if (nextAttempt >= MAX_ATTEMPTS) {
        setForceBankLock(true);
        setIsLoanValid(true); // stay on bank screen
        setFromBankFailure(false);
      }

      return nextAttempt;
    });

    return;
  }

  
  setBankAttemptCount(0);
  setIsBankVerified(true);
};







  
return (
  <StyleGuide>
    <StyledPage>
      <Grid>
        <div data-gridcolumnlayout={{ sm: '1/14' }}>

          {/* =====================================================
              STEP 1: LOAN NUMBER SCREEN
          ===================================================== */}
          {!isLoanValid && !forceBankLock && (

            <>
              <PageTitle>Confirm Wiring Instructions</PageTitle>

              {!isInvalidLoan  && !fromBankFailure && (
                <>
                  <PageWarning>
                    Use this tool to confirm our wiring instructions BEFORE wiring any funds.
                  </PageWarning>

                  <Instructions>
                    Please enter the loan number found on your payoff quote.
                  </Instructions>
                </>
              )}

              {showStandardError && (
                <ErrorBanner role="alert">
                  <ErrorIcon>!</ErrorIcon>
                  <div>
                    <strong>Oops!</strong> The information you have entered is incorrect.
                    <br />
                    Please try again.
                  </div>
                </ErrorBanner>
              )}

              {showLockedError && attemptCount >= MAX_ATTEMPTS && (
                <LockedErrorBanner role="alert">
                  <ErrorIcon>!</ErrorIcon>
                  <LockedErrorText>
                    The information you have entered is incorrect. If you are certain that
                    you entered the information correctly, please do not wire any funds until
                    you contact us during normal business hours, Monday–Thursday, 8am to 7pm ET
                    and 8am to 5pm ET on Fridays at <strong>866-654-0020</strong>.
                  </LockedErrorText>
                </LockedErrorBanner>
              )}

              {attemptCount < MAX_ATTEMPTS && (
                <div className="form-wrapper">
                  <input
                    type="text"
                    placeholder="Type your loan number"
                    value={loanNumber}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, '');
                      setLoanNumber(value);
                      setIsInvalidLoan(false);
                      setFromBankFailure(false);
                    }}
                  />
                  <button type="button" onClick={handleConfirm} disabled={!isLoanNumberEntered}>
                    Confirm
                  </button>
                </div>
              )}
            </>
          )}

          {/* =====================================================
              STEP 2: BANK DETAILS SCREEN
          ===================================================== */}
          {(isLoanValid || forceBankLock) && !isBankVerified && (
        
            <>
              <PageTitle>Confirm Wiring Instructions</PageTitle>
            {!forceBankLock && (
               <>
              <PageWarning>
                Use this tool to confirm our wiring instructions BEFORE wiring any funds.
              </PageWarning>

              <Instructions>
                Please enter the ABA/Bank Routing Number and Bank Account Number from
                your wiring instructions into the fields below and click Confirm.
              </Instructions>
               </>
            )}
              {showLockedError && bankAttemptCount >= MAX_ATTEMPTS && (
                <LockedErrorBanner role="alert">
                  <ErrorIcon>!</ErrorIcon>
                  <LockedErrorText>
                    The information you have entered is incorrect. If you are certain that
                    you entered the information correctly, please do not wire any funds until
                    you contact us during normal business hours, Monday–Thursday, 8am to 7pm ET
                    and 8am to 5pm ET on Fridays at <strong>866-654-0020</strong>.
                  </LockedErrorText>
                </LockedErrorBanner>
              )}

              {bankAttemptCount < MAX_ATTEMPTS && (
                <div className="form-wrapper">
                  <FormLabel>Enter the ABA/Bank Routing Number</FormLabel>
                  <input
                    type="text"
                    value={abaNumber}
                    inputMode="numeric"
                      maxLength={9}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, '');
                      setAbaNumber(value);
                      // setBankAttemptCount(0);
                    }}
                  />

                  <FormLabel>Enter the Bank Account Number</FormLabel>
                  <input
                    type="text"
                    value={accountNumber}
                    inputMode="numeric"
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, '');
                      setAccountNumber(value);
                      // setBankAttemptCount(0);
                    }}
                   
                  />

                  <button type="button" onClick={handleConfirm} disabled={!isBankFormValid || isBankLoading}>
                    Confirm
                  </button>
                </div>
              )}
            </>
          )}

          {/* =====================================================
              STEP 3: SUCCESS SCREEN
          ===================================================== */}
          {isLoanValid && isBankVerified && (
            <>
              <PageTitle>Confirm Wiring Instructions</PageTitle>

              <SuccessBanner role="status">
                <SuccessIcon>✓</SuccessIcon>
                <SuccessText>
                The ABA and Bank Account Number you entered are confirmed to be accurate.
                Thank you for verifying the wiring instructions prior to sending any funds.
              </SuccessText>

              </SuccessBanner>
            </>
          )}

          {/* =====================================================
              CYBERCRIME WARNING (ALWAYS VISIBLE)
          ===================================================== */}
          <div className="cybercrime-wrapper">
           
            {(isMobile || isTablet) && <CyberCrimeWarning />}
            {isDesktop && <CybercrimeWarningDesktop />}

          </div>

        </div>
      </Grid>
    </StyledPage>
  </StyleGuide>
);


  
}

export default HomeToolkit
